<template>
  <v-layout column fill-height style="overflow-y: auto; overflow-x: hidden">
    <template>
      <!--Button Bar-->
      <v-flex shrink class="pt-2 px-1">
        <v-card flat style="overflow-x: auto">
          <!--Create Task-->
          <v-tooltip top v-if="typeof userInfo.createTask != 'undefined' && intToBool(userInfo.createTask)">
            <v-btn
                fab
                dark
                small
                color="secondary"
                @click="createTaskFromMail()"
                slot="activator"
                class="pa-0 ma-1"
            >
              <v-icon>add</v-icon>
            </v-btn>
            <span>Create Task</span>
          </v-tooltip>
          <!--Link To Task-->
          <v-tooltip top>
            <v-btn
                fab
                dark
                small
                color="secondary"
                @click="linkTaskFromMail"
                slot="activator"
                class="pa-0 ma-1"
            >
              <v-icon>link</v-icon>
            </v-btn>
            <span>Link To Task</span>
          </v-tooltip>
          <!--Reply-->
          <v-tooltip top>
            <v-btn
                fab
                dark
                small
                color="primary"
                @click="mailReplyCompose(1)"
                slot="activator"
                class="pa-0 ma-1"
            >
              <v-icon dark>reply</v-icon>
            </v-btn>
            <span>Reply</span>
          </v-tooltip>
          <!--Reply To All-->
          <v-tooltip top>
            <v-btn
                fab
                dark
                small
                color="primary"
                @click="mailReplyCompose(2)"
                slot="activator"
                class="pa-0 ma-1"
            >
              <v-icon>reply_all</v-icon>
            </v-btn>
            <span>Reply To All</span>
          </v-tooltip>
          <!--Forward-->
          <v-tooltip top>
            <v-btn
                fab
                dark
                small
                color="primary"
                @click="mailReplyCompose(3)"
                slot="activator"
                class="pa-0 ma-1"
            >
              <v-icon>forward</v-icon>
            </v-btn>
            <span>Forward Mail</span>
          </v-tooltip>
          
          <!--Quick Tasks-->
          <template v-if="typeof userInfo.createTask != 'undefined' && intToBool(userInfo.createTask)">
            <v-tooltip top v-for="qt in sortedQuickTasks" :key="`quickTaskView1:${qt.id}`">
              <v-btn
                  fab
                  dark
                  small
                  color="secondary"
                  @click="quickTask(qt)"
                  slot="activator"
                  class="pa-0 ma-1"
              >
                <v-icon>{{ qt.config.icon }}</v-icon>
              </v-btn>
              <span>{{ qt.config.description }}</span>
            </v-tooltip>
          </template>
        </v-card>
      </v-flex>
      <v-flex xs12 class="pa-1">
        <v-card flat class="fill-height">
          <v-layout column fill-height>
            <!--Message Header-->
            <v-flex shrink>
              <div v-if="selectedMessage.taskIds && selectedMessage.taskIds.length">
                <v-layout row wrap>
                  <template v-for="taskId in selectedMessage.taskIds">
                    <v-flex shrink :key="taskId">
                      <v-menu open-on-hover offset-y nudge-left="150px">
                        <v-chip
                            slot="activator"
                            small
                            label
                            color="secondary"
                            text-color="white"
                        >
                          <v-icon left small>assignment_turned_in</v-icon>
                          Task #{{ taskId }}
                        </v-chip>
                        <div style="width: 400px; background: var(--card-back); cursor: pointer">
                          <task-loading-container
                              v-if="loadingTasks.includes(taskId)"
                              :task-id="taskId"
                          />
                          <task-container
                              v-else-if="tasks[taskId]"
                              :userInfo="userInfo"
                              :task="tasks[taskId]"
                              :taskBar="false"
                              :showNav="false"
                              @taskSelected="() => eventBus.$emit('gotoTask', tasks[taskId])"
                          />
                        </div>
                      </v-menu>
                    </v-flex>
                  </template>
                </v-layout>
              </div>
              <v-layout column style="overflow-x: hidden">
                <v-flex shrink style="overflow-x: hidden">
                  <v-layout row style="overflow-x: hidden" align-center>
                    <v-flex shrink>
                    </v-flex>
                    <v-flex style="overflow-x: hidden" class="px-2 pt-2">
                      <span class="subheading font-weight-bold;">{{ selectedMessage.subject }}</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                
                <!--                {-->
                <!--                "summary": "Dear valued customer • FNB :-) R612.90 reserved for purchase @ Checkers Sixty60 from FNB card a/c..053000 using card..3133. Avail R3354. 2Apr 12:25 Please do NOT reply to this message as it is sent from an unattended mailbox.",-->
                <!--                "sentDateInGMT": "1743614729000",-->
                <!--                "calendarType": 0,-->
                <!--                "subject": "FNB :-) R612.90 reserved for purchase @ Checkers Sixty60 from FNB card a/c..053000 using card..3133.  2Apr 12:25",-->
                <!--                "messageId": "1743589534550030400",-->
                <!--                "flagid": "flag_not_set",-->
                <!--                "status2": "0",-->
                <!--                "priority": "3",-->
                <!--                "hasInline": "true",-->
                <!--                "toAddress": "&lt;JUAN@ZABACKUP.CO.ZA&gt;",-->
                <!--                "folderId": "1284273000000008014",-->
                <!--                "ccAddress": "Not Provided",-->
                <!--                "hasAttachment": "0",-->
                <!--                "size": "37065",-->
                <!--                "sender": "inContact@fnb.co.za",-->
                <!--                "receivedTime": "1743589534531",-->
                <!--                "fromAddress": "inContact@fnb.co.za",-->
                <!--                "status": "1",-->
                <!--                "date": "2025-04-02T10:25:29.000Z",-->
                <!--                "taskIds": [],-->
                <!--                "viewDate": "2 Apr 25"-->
                <!--                }-->
                
                
                <v-flex shrink style="overflow-x: hidden" class="px-2">
                  <v-layout row style="overflow-x: hidden" align-center>
                    <v-flex shrink class="pa-1">
                      <v-avatar class="lighten-1" size="40" color="grey">
                        <v-icon dark>alternate_email</v-icon>
                      </v-avatar>
                    </v-flex>
                    
                    <v-flex xs12 style="overflow-x: hidden" class="pl-1 pr-1">
                      <v-layout style="overflow-x: hidden" column>
                        <v-flex style="overflow-x: hidden" shrink>
                          <v-layout style="overflow-x: hidden" row align-center>
                            <v-flex xs12 style="overflow-x: hidden" class="text-truncate subheading"
                                    v-html="selectedMessage.sender">
                            </v-flex>
                            <v-flex>
                              <span class="greyType--text caption text-truncate">{{
                                  getLongDate(selectedMessage.date)
                                }}</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex style="overflow-x: hidden" class="text-truncate caption pt-1" shrink
                                v-if="selectedMessage.toAddress && selectedMessage.toAddress !== 'Not Provided'"
                                v-html="'To: ' + selectedMessage.toAddress"/>
                        <v-flex style="overflow-x: hidden" class="text-truncate caption pt-1" shrink
                                v-if="selectedMessage.ccAddress && selectedMessage.ccAddress !== 'Not Provided'"
                                v-html="'To: ' + selectedMessage.ccAddress"/>
                      </v-layout>
                    </v-flex>
                  
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <!--Message Body-->
            <v-flex xs12 style="overflow-y: auto; overflow-x: auto">
              <div class="fill-height pb-2 px-2">
                <div class="c-d-flex c-align-center c-justify-center fill-height" v-if="loadingHtml">
                  <v-progress-circular
                      :size="24"
                      :width="2"
                      color="primary"
                      indeterminate
                  ></v-progress-circular>
                </div>
                <iframe
                    v-else-if="iframeSrc"
                    :src="iframeSrc"
                    ref="zohoFrame"
                    style="width: 100%; background: #ffffff"
                    frameborder="0"
                    class="fill-height"
                    @load="iframeReset"
                >
                </iframe>
                <!--                @load="iframeReset"-->
              </div>
            </v-flex>
            
            <v-flex shrink
                    v-if="!loadingHtml && messageData && messageData.attachments && messageData.attachments.length">
              <v-layout row wrap align-center>
                <!--                <v-flex shrink v-if="!showEmbedded && embeddedAttachmentsLength > 0">-->
                <!--                  <v-tooltip top>-->
                <!--                    <v-btn-->
                <!--                        :color="loadingAttachments ? 'grey' : 'secondary'"-->
                <!--                        slot="activator"-->
                <!--                        icon-->
                <!--                        flat-->
                <!--                        @click="showEmbedded = true"-->
                <!--                        :loading="loadingAttachments"-->
                <!--                    >-->
                <!--                      {{`+${embeddedAttachmentsLength}`}}-->
                <!--                    </v-btn>-->
                <!--                    <span>Show Embedded Attachments</span>-->
                <!--                  </v-tooltip>-->
                <!--                </v-flex>-->
                <template v-for="attachment in attachments">
                  <v-flex shrink class="pa-1">
                    <v-card
                        hover
                        color="primary"
                        class="white--text"
                    >
                      <v-layout row align-center>
                        
                        <!--                        {-->
                        <!--                        "contentType": "application/pdf",-->
                        <!--                        "fileName": "Zabackup Terms and Conditions.pdf",-->
                        <!--                        "transferEncoding": "base64",-->
                        <!--                        "contentDisposition": "attachment",-->
                        <!--                        "generatedFileName": "Zabackup Terms and Conditions.pdf",-->
                        <!--                        "contentId": "2f1e000af087f22d989f518d13e73c03@mailparser",-->
                        <!--                        "checksum": "eee47854c5b9bf43f719d5e7fb0b2538",-->
                        <!--                        "length": 90784-->
                        <!--                        }-->
                        
                        
                        <template>
                          <!--                          <v-flex v-if="attachment.contentType === 'application/pdf'" class="pa-1 pl-2">-->
                          <!--                            <doc-view-->
                          <!--                                :url="`${serverAddress}/zoho/messages/attachment/${selectedAddress.tokenId}/${selectedMessage.messageId}/${attachment.contentId}/${token()}`"-->
                          <!--                            >-->
                          <!--                              <v-tooltip top>-->
                          <!--                                <v-icon-->
                          <!--                                    style="cursor: pointer"-->
                          <!--                                    small-->
                          <!--                                    slot="activator"-->
                          <!--                                    color="white"-->
                          <!--                                    class="ma-0"-->
                          <!--                                >-->
                          <!--                                  visibility-->
                          <!--                                </v-icon>-->
                          <!--                                <span>View Attachment</span>-->
                          <!--                              </v-tooltip>-->
                          <!--                            </doc-view>-->
                          <!--                          </v-flex>-->
                          <v-flex shrink class="pa-1">
                            <a
                                style="text-decoration: none"
                                :href="`${serverAddress}/zoho/messages/attachment/${selectedAddress.tokenId}/${selectedMessage.messageId}/${attachment.contentId}/${token()}`"
                                target="_blank">
                              <v-tooltip top>
                                <v-icon
                                    style="cursor: pointer"
                                    small
                                    slot="activator"
                                    color="white"
                                    class="ma-0"
                                >
                                  {{ 'attachment' }}
                                </v-icon>
                                <span>Download Attachment</span>
                              </v-tooltip>
                            </a>
                          </v-flex>
                          <a
                              style="text-decoration: none"
                              :href="`${serverAddress}/zoho/messages/attachment/${selectedAddress.tokenId}/${selectedMessage.messageId}/${attachment.contentId}/${token()}`"
                              target="_blank"
                          >
                            <v-flex class="pa-1 pr-2 white--text caption">
                              {{ attachment.fileName }}
                            </v-flex>
                          </a>
                        </template>
                      
                      
                      </v-layout>
                    </v-card>
                  </v-flex>
                </template>
              
              </v-layout>
            
            </v-flex>
            <!--Attachments-->
          </v-layout>
        </v-card>
      </v-flex>
    </template>
  </v-layout>
</template>

<script>
import {eventBus} from "../../../../main";
import {codeBaseMixin} from "../../../../codeBaseMixin";
import TaskContainer from "../../../../components/TaskContainer/TaskContainer";
import TaskLoadingContainer from "../../../../components/TaskContainer/TaskLoadingContainer";
import {feed} from "../../../../feedSocket";
import DocView from "@/DocView/DocView";
import {serverAddress} from "@/axiosRequest";
import {token} from "@/tokenManSite";

export default {
  components: {DocView, TaskLoadingContainer, TaskContainer},
  mixins: [codeBaseMixin],
  props: {
    userInfo: Object,
    selectedAddress: Object,
    selectedLabel: Object,
    searchOptions: Object,
    getTaskHeader: Function,
    selectedMessage: Object,
  },
  data() {
    return {
      eventBus,
      console,
      loadingTasks: [],
      tasks: [],
      showLoading: false,
      loadingHtml: false,
      messageData: null,
      iframeSrc: null,
      showEmbedded: false,
      htmlMailBaseSrc: ''
    }
  },
  watch: {
    selectedMessage: {
      handler(newVal, oldVal) {
        this.refreshTasks()
        if (newVal != oldVal) {
          this.getFullMessageData()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
  
  },
  created() {
  
  },
  methods: {
    token,
    
    mailReplyCompose(type) {
      eventBus.$emit('zohoMailReplyCompose', type, this.selectedMessage);
    },
    
    linkTaskFromMail() {
      eventBus.$emit('linkZohoMail', true);
    },
    
    createTaskFromMail() {
      eventBus.$emit('createTaskZohoRun', null);
    },
    
    quickTask(qt) {
      eventBus.$emit('createTaskZohoRun', {workflow: qt.config.workflow, folder: qt.config.folder});
    },
    
    async getFullMessageData() {
      try {
        this.loadingHtml = true
        
        this.iframeSrc = null
        
        this.messageData = await this.$newReq('POST', 'zoho/messages/viewData', {
          tokenId: this.selectedAddress.tokenId,
          folderId: this.selectedLabel.folderId,
          messageId: this.selectedMessage.messageId,
        })
        
        const body = this.messageData.html || this.messageData.text?.replaceAll(/\n/g, '<br />') || ''
        
        // Create a new Blob with the HTML content. Adjust the MIME type if necessary.
        const blob = new Blob([body], {type: 'text/html'});
        
        // Generate a blob URL
        this.iframeSrc = URL.createObjectURL(blob);
        
        console.log(this.messageData)
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        this.loadingHtml = false
      }
    },
    
    iframeReset(event) {
      let doc = this.$refs.zohoFrame;
      // doc.html = this.messageHtml;
      let content = (doc.contentWindow || doc.contentDocument)
      if (content.document) content = content.document;
      doc = content;
      let head = doc.head;
      //Set The Style
      let style = doc.createElement('style');
      head.appendChild(style);
      style.type = 'text/css';
      style.appendChild(document.createTextNode(`
                    body {
                        font-family: sans-serif;
                    }
                        body::-webkit-scrollbar-track {
                        background-color: #ededed;
                    }

                    body::-webkit-scrollbar {
                        width: 8px;
                        height: 8px;
                        background-color: #F5F5F5;
                    }

                    body::-webkit-scrollbar-thumb {
                        background-color: #00897B;
                    }`));
      var base = doc.createElement('base');
      head.appendChild(base);
      
      this.$refs.zohoFrame.contentWindow.document.body.innerHTML = this.$refs.zohoFrame.contentWindow.document.body.innerHTML;
      
      this.showFrame = true;
    },
    
    async refreshTasks() {
      for (const taskId of this.selectedMessage.taskIds) {
        try {
          if (!this.tasks[taskId]) {
            this.loadingTasks.push(taskId)
            this.tasks[taskId] = await this.getTaskHeader(taskId)
            this.loadingTasks = this.loadingTasks.filter(v => v !== taskId)
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
  },
  computed: {
    
    serverAddress: () => serverAddress,
    
    sortedQuickTasks() {
      return this.userInfo.quickTasks.filter(() => true).sort((a, b) => a['config']['order'] < b['config']['order'] ? -1 : 1);
    },
    
    attachments() {
      return this.messageData?.attachments || []
      // if (this.messageData?.attachments?.length > 0) {
      //   return this.showEmbedded ? this.message.attachments : this.message.attachments.filter((obj) => obj.type != 'embedded')
      // } else {
      //   return null
      // }
    },
    
    
    embeddedAttachmentsLength() {
      try {
        return this.messageData?.attachments?.filter((obj) => obj.type === 'embedded').length
      } catch (e) {
        // eslint-disable-next-line
        console.log(e)
        return []
      }
    },
    
    
  }
}
</script>

<style scoped>
</style>
